import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import React from 'react';
import NumberFormat from 'react-number-format';

interface Props extends ICellRendererParams {}

const YearWithValueCellRenderer: React.FC<Props> = ({ value }) => {
  return value ? (
    <>
      {value.year}:{' '}
      {typeof value.value === 'number' && (
        <NumberFormat value={value.value} displayType={'text'} thousandSeparator={true} />
      )}
      {typeof value.value !== 'number' && `${value.value}`}
    </>
  ) : null;
};

export default YearWithValueCellRenderer;
